import {
  Columns3,
  CreditCard,
  HelpCircle,
  LayoutTemplate,
  MessageSquareQuote,
  Megaphone,
  Grid3X3,
  Code,
  Type,
  Image,
  BarChart3,
  CalendarCheck,
  ListOrdered,
  Phone,
  Users,
  Layers,
  List,
  LayoutGrid,
  Table2,
  Award,
  Video,
  MapPin,
  Newspaper,
} from "lucide-react";
import type { ComponentType } from "react";

/**
 * Maps section registry types to small glyph icons for the outline rail.
 */
export const SECTION_ICONS: Record<
  string,
  ComponentType<{ size?: number; strokeWidth?: number }>
> = {
  Hero: LayoutTemplate,
  FeatureGrid: Columns3,
  PricingTable: CreditCard,
  FAQ: HelpCircle,
  Testimonials: MessageSquareQuote,
  CTABanner: Megaphone,
  BlogGrid: Grid3X3,
  BlogList: Newspaper,
  CustomEmbed: Code,
  TextBlock: Type,
  ImageText: Image,
  StatsBar: BarChart3,
  BookingWidget: CalendarCheck,
  ProcessSteps: ListOrdered,
  ContactCard: Phone,
  TeamGrid: Users,
  FeatureShowcase: Layers,
  FeatureList: List,
  CTACards: LayoutGrid,
  ComparisonTable: Table2,
  LogoStrip: Award,
  VideoEmbed: Video,
  MapEmbed: MapPin,
};

/**
 * Human-friendly labels for section types, shown in small caps.
 */
export const SECTION_LABELS: Record<string, string> = {
  Hero: "HERO",
  FeatureGrid: "FEATURE GRID",
  PricingTable: "PRICING",
  FAQ: "FAQ",
  Testimonials: "TESTIMONIALS",
  CTABanner: "CTA BANNER",
  BlogGrid: "BLOG GRID",
  BlogList: "BLOG LIST",
  CustomEmbed: "EMBED",
  TextBlock: "TEXT",
  ImageText: "IMAGE + TEXT",
  StatsBar: "STATS",
  BookingWidget: "BOOKING",
  ProcessSteps: "PROCESS",
  ContactCard: "CONTACT",
  TeamGrid: "TEAM",
  FeatureShowcase: "SHOWCASE",
  FeatureList: "FEATURE LIST",
  CTACards: "CTA CARDS",
  ComparisonTable: "COMPARISON",
  LogoStrip: "LOGOS",
  VideoEmbed: "VIDEO",
  MapEmbed: "MAP",
};
